import React, { Component } from "react";
import { withRouter, Redirect } from "react-router-dom";
import { connect } from "react-redux";

import LoanDetails from "../loan-details/loan-details.component";
import PaymentDetails from "../payment-details/payment-details.component";
import PaymentBreakdown from "../payment-breakdown/payment-breakdown.component";
import LoanReviewForm from "../forms/loan-review/loan-review-form.component";

import { changeCurrentStep } from "../../actions/processStep.actions";
import { submitPayment } from "../../actions/payment.actions";
import { removePaymentErrorProperty } from "../../actions/payment.actions";
import { modifyHeader, toggleEditMode } from "../../actions/appStatus.actions";
import { loanReviewHeader } from "../../utils/content";
import { scrollTo } from "../../utils/smoothScroll";
import { showModal } from "../../actions/modal.actions";
import Show from "../../utils/show.component";
import { formatDate } from "../../utils/utils";

class LoanReviewComponent extends Component {
  constructor(props) {
    super(props);
    this.props.changeCurrentStep(3);
    this.props.modifyHeader(loanReviewHeader.header, loanReviewHeader.description);
    this.goBackToPayments = this.goBackToPayments.bind(this);
    this.submitForm = this.submitForm.bind(this);
  }

  goBackToPayments() {
    scrollTo(0, 1000);
    this.props.removePaymentErrorProperty();
    this.props.toggleEditMode();
  }

  submitForm(formName) {
    let paymentDetails = {};

    if (this.props.form[formName]) {
      paymentDetails = this.props.form[formName].values;
    }

    scrollTo(0, 1000);
    // Submit the payment to EPX or ACH
    this.props.submitPayment(
      { ...this.props.payment, ...paymentDetails },
      this.props.appStatus.paymentType
    );
  }

  render() {
    const mockMaxPayoffAmount = 40000;
    const mockMinPayoffAmount = 30000;
    const amountToUse = this.props.payment.PaymentAmount || this.props.payment.Amount;

    // If user hits the change button and the payment error property is null
    if (this.props.appStatus.processComplete === true) {
      return <Redirect to="/complete" />;
    }
    // If the user wants to change their details or the api returned an error
    if (this.props.payment.PaymentError || this.props.appStatus.editMode) {
      if (this.props.appStatus.paymentType === "Appraisal") {
        return <Redirect to="/appraisal-charge/edit" />;
      } else {
        return <Redirect to="/loan-payment" />;
      }
    }
    return (
      <div
        className="container app-container"
        style={this.props.loanNumber === undefined ? { marginTop: "80px" } : {}}
      >
        {/* Show loan details box again */}
        <LoanDetails
          isPayoff={this.props.payoffCheck.PaymentTypeChangedToPayoff}
          feeType={this.props.payment.feeType}
          description={this.props.loans.Description}
          loanNumber={this.props.loans.LoanNumber}
          nextDueDate={this.props.loans.NextDueDate}
          amountDue={this.props.loans.AmountDue}
          nextNextDueDate={this.props.loans.NextNextDueDate}
          regularMinimumPaymentAmount={this.props.loans.RegularMinimumPaymentAmount}
          amountPastDue={this.props.loans.AmountPastDue}
          showModal={this.props.showModal}
          ChargeOffIsRequired={this.props.loans.ChargeOffIsRequired}
          showRegularAmountWarning={this.props.loans.ShowRegularAmountWarning}
        />
        <PaymentDetails
          goBackToPayments={this.goBackToPayments}
          NameOnCard={this.props.payment.NameOnCard || this.props.payment.NameOnAccount}
          CardType={this.props.payment.CardType || null}
          CardNumberLastFour={
            this.props.payment.CardNumberLastFour || this.props.payment.AccountNumber.slice(-4)
          }
          paymentType={this.props.appStatus.paymentType}
        />
        <PaymentBreakdown
          PaymentAmount={this.props.payment.PaymentAmount || this.props.payment.Amount}
          ConvenienceFee={
            this.props.appStatus.paymentType === "ach" ? 0 : this.props.loans.DefaultFeeAmount
          }
          PostDate={this.props.payment.PostDate || null}
          ChargeOffIsRequired={this.props.loans.ChargeOffIsRequired}
          paymentType={this.props.appStatus.paymentType}
        />
        <Show condition={this.props.payoffCheck.PaymentTypeChangedToPayoff === true}>
          <div className="row-no-gutters">
            <div className="col-12 p-0">
              <div className="payoff-msg primary">
                Payment will be applied on or before {formatDate(this.props.payment.PostDate)}. This
                payment will result in the <u>payoff of this loan.</u>
              </div>
            </div>
          </div>
        </Show>
        <LoanReviewForm
          submitForm={this.submitForm}
          formValues={this.props.form.LoanReview}
          paymentType={this.props.appStatus.paymentType}
          payoffCheck={this.props.payoffCheck}
        />
      </div>
    );
  }
}

// Map global store to component props
const mapStateToProps = (state) => state;

// Hook up actions to component
const mapDispatchToProps = {
  changeCurrentStep,
  submitPayment,
  removePaymentErrorProperty,
  modifyHeader,
  toggleEditMode,
  showModal,
};

//Connect to Redux store
const LoanReview = withRouter(connect(mapStateToProps, mapDispatchToProps)(LoanReviewComponent));

export default LoanReview;



// WEBPACK FOOTER //
// ./src/components/loan-review/loan-review.component.js